export const USER_RESOURCE_STORE = 'USER_RESOURCE_STORE';
export const USER_RESOURCE_UPDATE = 'USER_RESOURCE_UPDATE';
export const USER_RESOURCE_DESTROY = 'USER_RESOURCE_DESTROY';
